import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NavbarComponent } from '../../../layout/navbar/navbar.component';
import { PatientService } from '../../../core/services/patient.service';
import { AccessiService } from '../../../core/services/accessi.service';
import { PatientCreateComponent } from '../../patients/patient-create/patient-create.component';

@Component({
  selector: 'app-accesso-create',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    PatientCreateComponent,
    NavbarComponent
  ],

  templateUrl: './accesso-create.component.html',
  styleUrls: ['./accesso-create.component.scss']
})
export class AccessoCreateComponent {

  selectedPatient: any = null;

  currentAccesso: any = null;

  cellulare = '';

  medico = '';

  medicoCellulare = '';

  medicoEmail = '';

  success = '';

  loading = false;

  error = '';

  previousAccesso: any = null;

  showImportContattiModal = false;

  // --- RICERCA PAZIENTE ---

  searchTerm = '';

  searchResults: any[] = [];

  searching = false;

  searchError = '';

  showNewPatientForm = false;

  constructor(
    private patientService: PatientService,
    private accessiService: AccessiService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    const idPaziente =
      Number(
        this.route.snapshot.paramMap.get(
          'idPaziente'
        )
      );

    if (idPaziente) {

      this.loadPatient(idPaziente);
    }
  }

  onSearch() {

    const term = this.searchTerm?.trim();

    if (!term) {
      this.searchError = 'Inserisci un nome, cognome o codice per cercare.';
      this.searchResults = [];
      return;
    }

    this.searching = true;
    this.searchError = '';
    this.searchResults = [];
    this.showNewPatientForm = false;

    this.patientService
      .search({
        nominativo: term
      })
      .subscribe({
        next: response => {

          this.searchResults = Array.isArray(response) ? response : [];
          this.searching = false;

          if (this.searchResults.length === 0) {
            this.searchError = 'Nessun paziente trovato. Puoi crearne uno nuovo qui sotto.';
            this.showNewPatientForm = true;
          }
        },
        error: () => {

          this.searching = false;
          this.searchError = 'Errore durante la ricerca pazienti.';
        }
      });
  }

  selectPatient(patient: any) {

    if (!patient?.idPaziente) return;

    this.patientService
      .getById(patient.idPaziente)
      .subscribe({
        next: response => {

          this.selectedPatient = response;
          this.searchResults = [];
          this.searchTerm = '';
          this.showNewPatientForm = false;
          this.createAccesso();
        },
        error: () => {

          this.error = 'Errore caricamento paziente';
        }
      });
  }

  toggleNewPatientForm() {

    this.showNewPatientForm = !this.showNewPatientForm;

    if (this.showNewPatientForm) {
      this.searchResults = [];
      this.searchError = '';
    }
  }

  loadPatient(
    idPaziente: number
  ): void {

    this.patientService
      .getById(idPaziente)
      .subscribe({
        next: patient => {

          this.selectedPatient = patient;
          this.createAccesso();
        },
        error: () => {

          this.error =
            'Errore caricamento paziente';
        }
      });
  }

  onPatientSelected(patient: any) {

    this.patientService
      .getById(patient.idPaziente)
      .subscribe({
        next: response => {

          // DTO DECRIPTATO

          this.selectedPatient =
            response;

          this.createAccesso();
        },
        error: () => {

          this.error =
            'Errore caricamento paziente';
        }
      });
  }

  createAccesso() {

    if (!this.selectedPatient) {
      return;
    }

    this.loading = true;

    const request = {

      idPaziente:
        this.selectedPatient.idPaziente,

      dataAccesso:
        new Date().toISOString()
    };

    this.accessiService
      .create(request)
      .subscribe({
        next: response => {

          this.currentAccesso = response;

          this.cellulare =
            response.cellulare || '';

          this.medico =
            response.medico || '';

          this.medicoCellulare =
            response.medicoCellulare || '';

          this.medicoEmail =
            response.medicoEmail || '';

          this.loadPreviousAccesso();

          this.loading = false;
        },
        error: () => {

          this.error =
            'Errore creazione accesso';

          this.loading = false;
        }
      });
  }

  saveAccesso() {

    if (!this.currentAccesso)
      return;

    const request = {

      dataAccesso:
        this.currentAccesso.dataAccesso,

      cellulare:
        this.cellulare,

      medico:
        this.medico,

      medicoCellulare:
        this.medicoCellulare,

      medicoEmail:
        this.medicoEmail,

      noteMedico:
        this.currentAccesso?.noteMedico || ''
    };

    this.accessiService
      .update(
        this.currentAccesso.idAccesso,
        request
      )
      .subscribe({
        next: response => {

          this.currentAccesso = response;

          this.success =
            'Accesso salvato correttamente';

          this.error = '';

          // REDIRECT DETTAGLIO ACCESSO

          this.router.navigate([
            '/accessi',
            this.currentAccesso.idAccesso
          ]);
        },
        error: () => {

          this.error =
            'Errore durante il salvataggio';

          this.success = '';
        }
      });
  }

  loadPreviousAccesso() {

    if (!this.selectedPatient)
      return;

    this.accessiService
      .getByPatient(
        this.selectedPatient.idPaziente
      )
      .subscribe({
        next: response => {

          // ESCLUDO ACCESSO CORRENTE

          const previous =
            response.filter(a =>
              a.idAccesso !==
              this.currentAccesso.idAccesso
            );

          // ORDINO DAL PIÙ RECENTE

          previous.sort(
            (a, b) =>
              new Date(b.dataAccesso).getTime() -
              new Date(a.dataAccesso).getTime()
          );

          // PRENDO ULTIMO ACCESSO

          if (previous.length > 0) {

            this.previousAccesso =
              previous[0];

            // MOSTRA MODAL

            this.showImportContattiModal =
              true;
          }
        }
      });
  }

  importPreviousContatti() {

    if (!this.previousAccesso)
      return;

    this.cellulare =
      this.previousAccesso.cellulare || '';

    this.medico =
      this.previousAccesso.medico || '';

    this.medicoCellulare =
      this.previousAccesso.medicoCellulare || '';

    this.medicoEmail =
      this.previousAccesso.medicoEmail || '';

    this.showImportContattiModal =
      false;
  }

  closeImportModal() {

    this.showImportContattiModal =
      false;
  }

}